import type { HugeiconsProps } from '@hugeicons/react-native';
import {
  Calendar03Icon as Calendar03SolidIcon,
  Clock01Icon as Clock01SolidIcon,
  Location01Icon as Location01SolidIcon,
  UserMultiple02Icon as UserMultiple02SolidIcon,
} from '@hugeicons-pro/core-solid-rounded';
import {
  Calendar03Icon,
  Clock01Icon,
  Location01Icon,
  UserMultiple02Icon,
} from '@hugeicons-pro/core-stroke-rounded';
import type { TFunction } from 'i18next';

import { eventListTypes, type EventListType } from '~/constants/lists';

export interface IEventListItem {
  value: EventListType;
  label: string;
  icon: HugeiconsProps['icon'];
  solidIcon: HugeiconsProps['icon'];
  href: string;
}

export const eventIcons: Record<
  EventListType,
  [HugeiconsProps['icon'], HugeiconsProps['icon']]
> = {
  upcoming: [Calendar03Icon, Calendar03SolidIcon],
  nearby: [Location01Icon, Location01SolidIcon],
  network: [UserMultiple02Icon, UserMultiple02SolidIcon],
  past: [Clock01Icon, Clock01SolidIcon],
};

export function getEventListHref(listType: EventListType): string {
  return `/events/${listType}`;
}

export function getEventListItems(t: TFunction): IEventListItem[] {
  return eventListTypes.map((listType) => {
    const [icon, solidIcon] = eventIcons[listType];

    return {
      value: listType,
      label: t(`events.${listType}_short`),
      icon,
      solidIcon,
      href: getEventListHref(listType),
    };
  });
}
